import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", {
  "class": "mb-8 text-3xl font-bold"
}, "Weekly Campaign Targets Report", -1);
var _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  "class": "mb-8 leading-normal"
}, "Sorry you do not have any data associated with your account.", -1);
var _hoisted_4 = {
  key: 1
};
var _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", {
  "class": "mb-8 text-3xl font-bold"
}, "Weekly Campaign Targets Report", -1);
var _hoisted_6 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6 px-6 py-4 w-full"
};
var _hoisted_7 = /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Tenant")]), /*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Value Type")])], -1);
var _hoisted_8 = {
  "class": "px-2 pb-4"
};
var _hoisted_9 = {
  "class": "px-2 pb-4"
};
var _hoisted_10 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6"
};
var _hoisted_11 = {
  "class": "text-center"
};
var _hoisted_12 = {
  "class": "text-center"
};
var _hoisted_13 = {
  "class": "flex justify-end"
};
var _hoisted_14 = {
  "class": "m-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_el_switch = _resolveComponent("el-switch");
  var _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_el_table = _resolveComponent("el-table");
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  var _component_el_pagination = _resolveComponent("el-pagination");
  return $props.weeks == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Head, {
    title: "Weekly Campaign Targets Report"
  }), _hoisted_2, _hoisted_3])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_Head, {
    title: "Weekly Campaign Targets Report"
  }), _hoisted_5, _createElementVNode("table", _hoisted_6, [_hoisted_7, _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_8, [_createVNode(_component_el_select, {
    modelValue: $data.tenantId,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.tenantId = $event;
    }),
    onChange: $options.getTargetData,
    filterable: ""
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tenantList, function (tenant) {
        return _openBlock(), _createBlock(_component_el_option, {
          value: tenant,
          label: tenant
        }, null, 8, ["value", "label"]);
      }), 256))];
    }),
    _: 1
  }, 8, ["modelValue", "onChange"])]), _createElementVNode("td", _hoisted_9, [_createVNode(_component_el_switch, {
    modelValue: $data.valueType,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.valueType = $event;
    }),
    size: "large",
    "active-value": "percentage",
    "active-text": "Percentage",
    "inactive-text": "Absolute Value",
    "inactive-value": "absolute"
  }, null, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, [_createVNode(_component_el_skeleton, {
    loading: $data.isLoadingTargetData,
    animated: "",
    count: 9
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table, {
        data: $data.targetDataList,
        style: {
          "width": "100%"
        },
        ref: "targetData"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_table_column, {
            prop: "campaign_id",
            label: "Campaign Id"
          }), _createVNode(_component_el_table_column, {
            prop: "campaign_name",
            label: "Campaign Name"
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.weekDataList, function (w, key) {
            return _openBlock(), _createBlock(_component_el_table_column, null, {
              header: _withCtx(function () {
                return [_createElementVNode("div", _hoisted_11, "Week (" + _toDisplayString(w.week_number) + ", " + _toDisplayString(w.year) + ")", 1), _createElementVNode("div", _hoisted_12, _toDisplayString(w.start_date) + " to " + _toDisplayString(w.end_date), 1)];
              }),
              "default": _withCtx(function () {
                return [_createVNode(_component_el_table_column, {
                  label: "Contacts"
                }, {
                  "default": _withCtx(function (scope) {
                    return [scope.row[key].contacts_percent != -1 && $data.valueType == 'percentage' ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      "class": _normalizeClass(["text-center", scope.row[key].contacts_background]),
                      style: {
                        "font-weight": "bold"
                      }
                    }, _toDisplayString(scope.row[key].contacts_percent), 3)) : _createCommentVNode("", true), scope.row[key].contacts != -1 && $data.valueType == 'absolute' ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      "class": _normalizeClass(["text-center", scope.row[key].contacts_background]),
                      style: {
                        "font-weight": "bold"
                      }
                    }, _toDisplayString(scope.row[key].contacts), 3)) : _createCommentVNode("", true)];
                  }),
                  _: 2
                }, 1024), _createVNode(_component_el_table_column, {
                  label: "Companies"
                }, {
                  "default": _withCtx(function (scope) {
                    return [scope.row[key].companies_percent != -1 && $data.valueType == 'percentage' ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      "class": _normalizeClass(["text-center", scope.row[key].companies_background]),
                      style: {
                        "font-weight": "bold"
                      }
                    }, _toDisplayString(scope.row[key].companies_percent), 3)) : _createCommentVNode("", true), scope.row[key].companies != -1 && $data.valueType == 'absolute' ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      "class": _normalizeClass(["text-center", scope.row[key].companies_background]),
                      style: {
                        "font-weight": "bold"
                      }
                    }, _toDisplayString(scope.row[key].companies), 3)) : _createCommentVNode("", true)];
                  }),
                  _: 2
                }, 1024)];
              }),
              _: 2
            }, 1024);
          }), 256))];
        }),
        _: 1
      }, 8, ["data"])];
    }),
    _: 1
  }, 8, ["loading"]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_skeleton, {
    loading: $data.isLoadingTargetData,
    animated: "",
    count: 1
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next",
        total: $props.weeks,
        "current-page": $data.currentPage,
        "default-page-size": 4,
        onCurrentChange: $options.pageChange
      }, null, 8, ["total", "current-page", "onCurrentChange"])];
    }),
    _: 1
  }, 8, ["loading"])])])])])]));
}